import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import * as layoutConstants from '../constants/layout';

import VerticalLayout from '../layouts/Vertical';
import DetachedLayout from '../layouts/Detached';
import HorizontalLayout from '../layouts/Horizontal';
import FullLayout from '../layouts/Full';
import { useRoutes } from 'react-router-dom';
import OpenPayPg from '../pages/finanzas/OpenPayPg';
import CortesTecnicos from '../pages/finanzas/CortesTecnicos';
const EWalletDashboard = React.lazy(() => import('../pages/dashboard/E-Wallet'));
const Onus = React.lazy(() => import('../components/Fibra/Onus'));
const Olts = React.lazy(() => import('../pages/Fibra/OltPg'));
const Zonas = React.lazy(() => import('../pages/Fibra/ZonasPg'));
const Speed = React.lazy(() => import('../pages/Fibra/SpeedPg'));
const Box = React.lazy(() => import('../pages/Fibra/BoxNap'));
const Routers = React.lazy(() => import('../pages/red/RoutersPg'));
const RouterW = React.lazy(() => import('../pages/red/TabsRouter'));
const Ipv4 = React.lazy(() => import('../pages/red/Ipv4Pg'));
const Monitoreo = React.lazy(() => import('../pages/red/MonitRed'));
const Trafico = React.lazy(() => import('../pages/red/TraficoPg'));

const Internet = React.lazy(() => import('../pages/servicios/InternetPg'));
const Personalizado = React.lazy(() => import('../pages/servicios/PerzonalizadoPg'));
const Usuarios = React.lazy(() => import('../pages/clientes/UsuariosPg'));
const Baja = React.lazy(() => import('../pages/clientes/UsuariosBaja'));
const ViewCliente = React.lazy(() => import('../pages/clientes/ViewClientes'));
const MapCli2 = React.lazy(() => import('../pages/maps/MapContainer2'));
const Instalaciones = React.lazy(() => import('../pages/clientes/InstalacionesPg'));
const Addpago = React.lazy(() => import('../pages/finanzas/Addpago'));
const Transacciones = React.lazy(() => import('../pages/finanzas/Transacciones'));
const InegresosPg = React.lazy(() => import('../pages/finanzas/InegresosPg'));
const SatPg = React.lazy(() => import('../pages/finanzas/FacturasSat'));
const FacStatics = React.lazy(() => import('../pages/finanzas/FactStatics'));
const TickOpen = React.lazy(() => import('../pages/tickets/ListOpenPg'));
const TickClose = React.lazy(() => import('../pages/tickets/ListsCloseTk'));
const TickView = React.lazy(() => import('../pages/tickets/ViewTickts'));
const Settings = React.lazy(() => import('../pages/settings/Pgmenu'));
const General = React.lazy(() => import('../pages/settings/GeneralPg'));
const ConfSat = React.lazy(() => import('../pages/settings/PgFactElctro'));
const Zones = React.lazy(() => import('../pages/settings/PgZonasg'));
const Cron = React.lazy(() => import('../pages/settings/CronPg'));
const Db = React.lazy(() => import('../pages/settings/DataBase'));
const Logs = React.lazy(() => import('../pages/settings/Logs'));
const Systema = React.lazy(() => import('../pages/settings/SystemPg'));
const Personal = React.lazy(() => import('../pages/settings/PersonalPg'));
const Portal = React.lazy(() => import('../pages/settings/Portalpg'));
const AgenteOpp = React.lazy(() => import('../pages/settings/personal/PgEditAgente'));
const Perfil = React.lazy(() => import('../pages/settings/personal/Profile'));
const Pasarela = React.lazy(() => import('../pages/settings/PasarelaPagos'));
const FactGlobal = React.lazy(() => import('../pages/finanzas/FacturaGlobal'));
const WebProxy = React.lazy(() => import('../pages/settings/SettingProxy'));
// const Editor = React.lazy(() => import('../pages/settings/EditorPg'));
const Updates = React.lazy(() => import('../pages/UpdatesPg'));
const EmployesPg = React.lazy(() => import('../pages/nominas/EmployesPg'));
const EmployedPg = React.lazy(() => import('../pages/nominas/ProfileAg'));
const VacacionesPg = React.lazy(() => import('../pages/nominas/VacacionesPg'));
const SolicitudesPg = React.lazy(() => import('../pages/nominas/Solicitudes'));
const ActivitiesPg = React.lazy(() => import('../pages/tareas/ListActividades'));
const ListTareasPg = React.lazy(() => import('../pages/tareas/ListTreas'));
const TagsPg = React.lazy(() => import('../pages/clientes/EtiquetasPg'));
const Openpay = React.lazy(() => import('../pages/finanzas/OpenPayPg'));
const ZapSing = React.lazy(() => import('../components/settings/ZapSing'));
const CarsPg = React.lazy(() => import('../pages/settings/CarsPg'));
const ValesPg = React.lazy(() => import('../pages/nominas/ValesPg'));
const RolesPg = React.lazy(() => import('../pages/settings/personal/RolesPg'));
const WorkTeamPg = React.lazy(() => import('../pages/workteam/Workteam'));
const WorkTeeamPayPg = React.lazy(() => import('../pages/workteam/WorkPayments'));

const Colaborador = React.lazy(() => import('../pages/workteam/componentesClb/viewClb.js'));
const ClbWifi = React.lazy(() => import('../pages/workteam/clbwifi/viewClbWifi.js'));
const ChargesR = React.lazy(() => import('../pages/charges/ChargeScreens.js'));
const Actividades = React.lazy(() => import('../pages/tareas/ActivitiesList.js'));
const Estadistareas = React.lazy(() => import('../pages/tareas/GraphStadics.js'));

const loading = () => <div className=""></div>;

const LoadComponent = ({ Component }) => (
    <Suspense fallback={loading()}>
        <Component />
    </Suspense>
);

export const App = () => {
    const { layout } = useSelector((state) => ({
        layout: state.Layout,
    }));
    const getLayout = () => {
        let layoutCls = VerticalLayout;

        switch (layout.layoutType) {
            case layoutConstants.LAYOUT_HORIZONTAL:
                layoutCls = HorizontalLayout;
                break;
            case layoutConstants.LAYOUT_DETACHED:
                layoutCls = DetachedLayout;
                break;
            case layoutConstants.LAYOUT_FULL:
                layoutCls = FullLayout;
                break;
            default:
                layoutCls = VerticalLayout;
                break;
        }
        return layoutCls;
    };
    let Layout = getLayout();

    return useRoutes([
        {
            path: '/',
            element: <Layout />,
            children: [
                {
                    path: '',
                    element: <LoadComponent Component={EWalletDashboard} />,
                },
                {
                    path: 'dashboard',
                    element: <LoadComponent Component={EWalletDashboard} />,
                },

                {
                    path: 'onus',
                    element: <LoadComponent Component={Onus} access="foacc" />,
                },
                {
                    path: 'olt',
                    element: <LoadComponent Component={Olts} access="olacc" />,
                },
                {
                    path: 'zonas',
                    element: <LoadComponent Component={Zonas} access="fzacc" />,
                },
                {
                    path: 'speeds',
                    element: <LoadComponent Component={Speed} access="fpacc" />,
                },
                {
                    path: 'boxnap',
                    element: <LoadComponent Component={Box} access="fbacc" />,
                },
                {
                    path: 'routers',
                    element: <LoadComponent Component={Routers} access="r1acc" />,
                },
                {
                    path: 'router/:id',
                    element: <LoadComponent Component={RouterW} access="r1acc" />,
                },
                {
                    path: 'redipv4',
                    element: <LoadComponent Component={Ipv4} access="r2acc" />,
                },
                {
                    path: 'monitoreo',
                    element: <LoadComponent Component={Monitoreo} access="r3acc" />,
                },
                {
                    path: 'trafico',
                    element: <LoadComponent Component={Trafico} access="r4acc" />,
                },
                {
                    path: 'internet',
                    element: <LoadComponent Component={Internet} access="s1acc" />,
                },
                {
                    path: 'personalizado',
                    element: <LoadComponent Component={Personalizado} access="s2acc" />,
                },
                {
                    path: 'usuarios',
                    element: <LoadComponent Component={Usuarios} access="c1acc" />,
                },
                {
                    path: 'viewuser/:id',
                    element: <LoadComponent Component={ViewCliente} access="c1acc" />,
                },
                {
                    path: 'usuarios-baja',
                    element: <LoadComponent Component={Baja} access="cbsee" />,
                },
                {
                    path: 'mapaclientes',
                    element: <LoadComponent Component={MapCli2} access="c7acc" />,
                },
                {
                    path: 'instalaciones',
                    element: <LoadComponent Component={Instalaciones} access="c8acc" />,
                },
                {
                    path: 'addpago',
                    element: <LoadComponent Component={Addpago} access="f1acc" />,
                },
                {
                    path: 'transacciones',
                    element: <LoadComponent Component={Transacciones} access="f1acc" />,
                },
                {
                    path: 'global',
                    element: <LoadComponent Component={FactGlobal} access="f3estadis" />,
                },
                {
                    path: 'otros',
                    element: <LoadComponent Component={InegresosPg} access="f1acc" />,
                },
                {
                    path: 'sat',
                    element: <LoadComponent Component={SatPg} access="f3acc" />,
                },
                {
                    path: 'corte',
                    element: <LoadComponent Component={CortesTecnicos} access="f3tecs" />,
                },
                {
                    path: 'estadisticas',
                    element: <LoadComponent Component={FacStatics} access="f3estadis" />,
                },
                {
                    path: 'tickets/open',
                    element: <LoadComponent Component={TickOpen} access="tk1acc" />,
                },
                {
                    path: 'tickets/close',
                    element: <LoadComponent Component={TickClose} access="tk1acc" />,
                },
                {
                    path: 'viewticket/:id',
                    element: <LoadComponent Component={TickView} access="tk1acc" />,
                },
                {
                    path: 'ajustes',
                    element: <LoadComponent Component={Settings} access="aj1acc" />,
                },
                {
                    path: 'settings',
                    element: <LoadComponent Component={General} access="aj1general" />,
                },
                {
                    path: 'facelectro',
                    element: <LoadComponent Component={ConfSat} access="aj1factelec" />,
                },
                {
                    path: 'zons',
                    element: <LoadComponent Component={Zones} access="aj1location" />,
                },
                {
                    path: 'crontab',
                    element: <LoadComponent Component={Cron} access="aj1cron" />,
                },
                {
                    path: 'database',
                    element: <LoadComponent Component={Db} access="aj2bd" />,
                },
                {
                    path: 'digitaldoc',
                    element: <LoadComponent Component={ZapSing} access="aj1general" />,
                },
                {
                    path: 'logs',
                    element: <LoadComponent Component={Logs} access="aj1lgs" />,
                },
                {
                    path: 'system',
                    element: <LoadComponent Component={Systema} access="aj2sys" />,
                },
                {
                    path: 'web-proxy',
                    element: <LoadComponent Component={WebProxy} access="aj2sys" />,
                },
                {
                    path: 'agentes',
                    element: <LoadComponent Component={Personal} access="aj1manper" />,
                },
                {
                    path: 'roles',
                    element: <LoadComponent Component={RolesPg} access="aj1manper" />,
                },
                {
                    path: 'portal',
                    element: <LoadComponent Component={Portal} />,
                },
                {
                    path: 'pasarela',
                    element: <LoadComponent Component={Pasarela} />,
                },
                {
                    path: 'agente/:id/:id2',
                    element: <LoadComponent Component={AgenteOpp} access="aj1manper" />,
                },
                {
                    path: 'myprofile',
                    element: <LoadComponent Component={Perfil} />,
                },
                {
                    path: 'tareas',
                    element: <LoadComponent Component={ListTareasPg} />,
                },
                {
                    path: 'actividades',
                    element: <LoadComponent Component={ActivitiesPg} />,
                },
                {
                    path: 'updates',
                    element: <LoadComponent Component={Updates} />,
                },
                {
                    path: 'employes',
                    element: <LoadComponent Component={EmployesPg} />,
                },
                {
                    path: 'employed',
                    element: <LoadComponent Component={EmployedPg} />,
                },
                {
                    path: 'vacaciones',
                    element: <LoadComponent Component={VacacionesPg} />,
                },
                {
                    path: 'tags',
                    element: <LoadComponent Component={TagsPg} />,
                },
                {
                    path: 'activities',
                    element: <LoadComponent Component={Actividades} />,
                },
                {
                    path: 'todograph',
                    element: <LoadComponent Component={Estadistareas} />,
                },
                {
                    path: 'solicitudes',
                    element: <LoadComponent Component={SolicitudesPg} />,
                },
                {
                    path: 'pasarelas',
                    element: <LoadComponent Component={OpenPayPg} />,
                },
                {
                    path: 'cars',
                    element: <LoadComponent Component={CarsPg} />,
                },
                {
                    path: 'vales',
                    element: <LoadComponent Component={ValesPg} />,
                },
                {
                    path: 'teamwork',
                    element: <LoadComponent Component={WorkTeamPg} />,
                },
                {
                    path: 'teamworkpaym',
                    element: <LoadComponent Component={WorkTeeamPayPg} />,
                },
                {
                    path: 'colaboradores/:id',
                    element: <LoadComponent Component={Colaborador} />,
                },
                {
                    path: 'ClbWifi/:id',
                    element: <LoadComponent Component={ClbWifi} />,
                },
                {
                    path: 'recargas',
                    element: <LoadComponent Component={ChargesR} />,
                },
                {
                    path: '*',
                    element: <LoadComponent Component={EWalletDashboard} />,
                },
            ],
        },
    ]);
};
